/* eslint-disable compat/compat */
import { AMPLIENCE_HOST } from '@tgg/common-types';

import {
    ImageMediaQuery,
    QueryParameters,
    UrlMediaSet,
} from '../CustomPicture.types';

interface GetAmplienceUrlArguments {
    name: string;
    query?: ImageMediaQuery;
}

export const getAmplienceUrl = ({
    name,
    query,
}: GetAmplienceUrlArguments): UrlMediaSet => {
    const { defaultHost, endpoint } = AMPLIENCE_HOST;
    const defaultUrl = new URL(
        `https://${defaultHost}/i/${endpoint}/${encodeURIComponent(name)}`,
    );
    const mobileUrl = new URL(
        `https://${defaultHost}/i/${endpoint}/${encodeURIComponent(name)}`,
    );

    if (query?.default) {
        defaultUrl.search = getQueryInstance(query.default);
    }

    if (query?.mobile) {
        mobileUrl.search = getQueryInstance(query.mobile);
    }

    return {
        mobileUrl: mobileUrl.toString(),
        defaultUrl: defaultUrl.toString(),
    };
};

const getQueryInstance = (queryParameters: QueryParameters) => {
    const {
        crop,
        poi,
        fmt = 'auto',
        qlt = 'default',
        ...restImageProperties
    } = queryParameters;

    const query = new URLSearchParams({ fmt, qlt });

    Object.entries(restImageProperties)
        .filter(([_, value]) => !!value)
        .forEach(([key, value]) => query.set(key, value));

    if (crop) {
        query.set('crop', `${crop.x},${crop.y},${crop.width},${crop.height}`);
    }

    if (poi) {
        query.set('poi', `${poi.x},${poi.y},${poi.width},${poi.height}`);
    }

    return query.toString();
};
